import { render, staticRenderFns } from "./ActivitySpeaking.vue?vue&type=template&id=05bce6d2&scoped=true"
import script from "./ActivitySpeaking.vue?vue&type=script&lang=ts"
export * from "./ActivitySpeaking.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySpeaking.vue?vue&type=style&index=0&id=05bce6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bce6d2",
  null
  
)

export default component.exports